import {Button, Image} from "antd";
import {
  StyledPortfolioImagesItemImageWrapper,
  StyledPortfolioImagesItemWrapper,
} from "./styles";
import {StoreServicePortfolioImagesItemProps} from "./types";
import {DeleteOutlined} from "@ant-design/icons";

export function StoreServicePortfolioImagesItem({
  deleteFunction,
  imgSrc,
  isDeleteLoading,
  uploadStatus,
}: StoreServicePortfolioImagesItemProps) {
  return (
    <StyledPortfolioImagesItemWrapper>
      <StyledPortfolioImagesItemImageWrapper>
        <Image
          style={{
            borderRadius: "4px",
            objectFit: "cover",
          }}
          width={"100%"}
          height={"100%"}
          src={imgSrc}
        />
      </StyledPortfolioImagesItemImageWrapper>
      {uploadStatus === "pending" && (
        <div>
          <Button
            loading={isDeleteLoading}
            onClick={deleteFunction}
            size="small"
            type="text"
            icon={<DeleteOutlined />}
          />
        </div>
      )}
    </StyledPortfolioImagesItemWrapper>
  );
}
